import { render, staticRenderFns } from "./検査２.vue?vue&type=template&id=cb4a352c&scoped=true&"
import script from "./検査２.vue?vue&type=script&lang=js&"
export * from "./検査２.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4a352c",
  null
  
)

export default component.exports